<script>
    export default {
        props: {
            value: null,
            language: null,
        },
        data() {
            return {
                loading: false,
                newTranslationValue: ''
            }
        },
        computed: {
            valueLang: function () {
                if (!this.language || !this.value) {
                    return null;
                }

                return _.head(_.filter(this.value.translations, (translationOfValue) => {
                  return translationOfValue.language_id === this.language.id;
                }));
            }
        },
        methods: {
            updateValueText() {
                this.loading = true;

                if (this.valueLang) {
                    this.valueLang.text = this.newTranslationValue;

                    axios.put(Scoop.baseUrl + '/edito/attribute-values-lang/' + this.valueLang.id, {
                        'text': this.newTranslationValue,
                    }).then(() => {
                        this.loading = false;
                        toastr.success('Die Übersetzung wurde gespeichert');
                    });
                } else {
                    // Create new translation
                    axios.post(Scoop.baseUrl + '/edito/attribute-values-lang', {
                        'master_id': this.value.id,
                        'language_id': this.language.id,
                        'text': this.newTranslationValue,
                    }).then((response) => {
                        toastr.success('Die Übersetzung wurde gespeichert');

                        this.value.translations.push(response.data);

                        this.loading = false;
                    });
                }

            }
        }
    }
</script>

<style>
    .multilang-field textarea {
        width: 100% !important;
    }
</style>

<template>
    <div class="input-group">

        <span class="loading input-group-addon" v-if="loading">
            <i class="fa fa-spinner fa-spin"></i>
        </span>
        <input type="text" class="form-control" :value="valueLang ? valueLang.text : newTranslationValue"
               @input="newTranslationValue = $event.target.value"
               @change="updateValueText" :disabled="loading">
        <span class="input-group-addon">
            <span class="text-uppercase m-r-xs" v-text="language.shortCode"></span>
                <i class="fa fa-language"></i>
            </span>

    </div>

</template>
